import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Hồ sơ tàu (VesselsScreen.tsx).
addMessages('vi', {
  'vs.vessel': 'Tàu · chuyến',
  'vs.carrier': 'Hãng',
  'vs.cyLeft': 'CY còn',
  'vs.changes': 'Đổi lịch',
  'vs.changesN': '{n} lần đổi lịch',
  'vs.none': 'chưa có',
  'vs.title': 'Hồ sơ tàu',
  'vs.sub': 'Chuyến, cut-off, hải trình, booking',
  'vs.empty': 'Chưa có tàu nào',
  'vs.noperm': 'Không có quyền xem hồ sơ tàu',
  'vs.err': 'Không tải được hồ sơ tàu',
  'vs.retry': 'Thử lại',
  'vs.search': 'Tìm tàu',
  'vs.searchPh': 'Tìm tên tàu, chuyến, hãng, IMO',
  'vs.noMatch': 'Không có tàu khớp',
  'vs.list': 'Danh sách tàu',
});
addMessages('en', {
  'vs.vessel': 'Vessel · voyage',
  'vs.carrier': 'Carrier',
  'vs.cyLeft': 'CY left',
  'vs.changes': 'Changes',
  'vs.changesN': '{n} schedule changes',
  'vs.none': 'n/a',
  'vs.title': 'Vessel profiles',
  'vs.sub': 'Voyages, cut-offs, itinerary, bookings',
  'vs.empty': 'No vessels yet',
  'vs.noperm': 'No permission to view vessel profiles',
  'vs.err': 'Could not load vessel profiles',
  'vs.retry': 'Retry',
  'vs.search': 'Search vessels',
  'vs.searchPh': 'Search vessel, voyage, carrier, IMO',
  'vs.noMatch': 'No matching vessels',
  'vs.list': 'Vessel list',
});
